<bulb-menu-list-panel [menuItems]="menuItems">
  <ng-template #buttonTemplate>
    <button #toggleEl>
      <svg-icon
        key="ellipsis-h"
        fontSize="2em"
        class="menu-list-button">
      </svg-icon>
    </button>
  </ng-template>

  <ng-template *ngIf="unit.unitType !== 'CompositeUnit' && unit.unitType !== 'AssignmentCompositeUnit' && (!unit.isPinned || (unit.isPinned && canEdit))" #footerTemplate>
    <dl class="tile-info-data">
      <dt class="__title" transloco="tiles.tilesMenu.lastModified">Last Modified:</dt>
      <dd class="__description">
        {{ unit.lastModified
          ? (unit.lastModified | date: 'M/dd/yyyy')
          : "-"
        }}
      </dd>
    </dl>
    <dl class="tile-info-data">
      <dt class="__title" transloco="tiles.tilesMenu.lastShared">Last Shared:</dt>
      <dd class="__description">
        {{ unit.publishedDate
          ? (unit.publishedDate | date: 'M/dd/yyyy')
          : "-"
        }}
      </dd>
    </dl>
  </ng-template>
</bulb-menu-list-panel>
